import PropTypes from 'prop-types';
import React from 'react';

const EntryPlaceholder = ({ size }) => {
    return (
        <svg viewBox={`0 0 ${size} ${size}`} className="avatar-placeholder">
            <rect
                x={1}
                y={1}
                width={size - 2}
                height={size - 2}
                fill="none"
                strokeWidth="2"
                strokeDasharray="5,4"
                vectorEffect="non-scaling-stroke"
            />
            <text x={size / 2} y={size / 2} textAnchor="middle" dominantBaseline="middle">
                
            </text>
        </svg>
    );
};

EntryPlaceholder.propTypes = {
    size: PropTypes.number.isRequired,
};

export default EntryPlaceholder;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/entry-placeholder.jsx